const SELECTION_NEW_ENTRY = 1;
const SELECTION_NEW_EXIT = -1;
const SELECTION_NULL = 0;
const SELECTION_OLD_ENTRY = 2;
const SELECTION_OLD_EXIT = -2;

export {
    SELECTION_NEW_ENTRY,
    SELECTION_NEW_EXIT,
    SELECTION_NULL,
    SELECTION_OLD_ENTRY,
    SELECTION_OLD_EXIT
};
